import React from 'react';
import News from './News';

const NewsRoutes = {
	news: {
		tag: 'news_articles',
		path: '/news',
		auth: true,
		layout: 'investor',
		component: <News page="articles" />,
	},
};

export default NewsRoutes;
